import React from 'react';

const CancellationPolicy = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6 font-handwritten">Cancellation Policy</h1>
      <div className="space-y-6 text-gray-700 dark:text-gray-300">
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Order Cancellation Policy</h3>
          <p className="mb-4 text-gray-600 dark:text-gray-300">
            At Ry&apos;s Circus, we understand that circumstances may arise requiring you to cancel your order. Please review our cancellation policy below:
          </p>
          
          <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg mt-3">
            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Pre-Shipment Cancellations</h4>
            <ul className="list-disc pl-5 space-y-1">
              <li>Orders can be canceled at no charge before they are shipped</li>
              <li>To cancel an order, contact our customer service team via email</li>
              <li>Provide your order number and the reason for cancellation</li>
              <li>Items marked as &quot;Custom&quot; or &quot;Made-to-Order&quot; may not be eligible for cancellation once production has begun</li>
            </ul>
          </div>
          
          <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg mt-3">
            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Post-Shipment Cancellations</h4>
            <p>Once an order has been shipped, it cannot be cancelled. However, you may refuse delivery or return the item according to our Return Policy once received.</p>
          </div>
        </section>
        
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Cancellation Timeframe</h3>
          <p className="mb-2">For most orders, you have up to 24 hours after placing your order to request a cancellation. Custom or made-to-order items may have different cancellation timeframes, which will be clearly indicated during the ordering process.</p>
          <p>Orders are typically processed within 1-2 business days. Once an order enters the processing stage, cancellation may not be possible.</p>
        </section>
        
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Refunds for Cancelled Orders</h3>
          <p className="mb-2">When an order is successfully cancelled:</p>
          
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>The full purchase amount will be refunded to the original payment method</li>
            <li>Refunds typically process within 3-5 business days</li>
            <li>The time it takes for the refund to appear in your account depends on your payment provider</li>
          </ul>
          
          <p className="mt-2">You will receive an email confirmation when your cancellation has been processed.</p>
        </section>
        
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Subscription Cancellations</h3>
          <p className="mb-2">For subscription-based products or services:</p>
          
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>You may cancel your subscription at any time through your account settings</li>
            <li>Cancellations will take effect at the end of the current billing cycle</li>
            <li>No partial refunds are provided for unused portions of the current billing period</li>
            <li>You will continue to have access to the subscription until the end of the current billing period</li>
          </ul>
        </section>
        
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Event or Service Cancellations</h3>
          <p className="mb-2">For events, workshops, or services:</p>
          
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>Cancellations made 14 or more days before the scheduled date are eligible for a full refund</li>
            <li>Cancellations made 7-13 days before the scheduled date are eligible for a 50% refund</li>
            <li>Cancellations made less than 7 days before the scheduled date are not eligible for a refund</li>
            <li>In case of emergency or extenuating circumstances, contact us to discuss possible exceptions</li>
          </ul>
        </section>
        
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Contact Information</h3>
          <p className="mb-2">For cancellation requests or inquiries, please contact our customer service team:</p>
          
          <ul className="list-none space-y-1 mt-2">
            <li>Email: <a href="mailto:orders@ryscircus.com" className="text-blue-600 dark:text-blue-400 hover:underline">orders@ryscircus.com</a></li>
            <li>Hours: Monday-Friday, 9am-5pm EST</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default CancellationPolicy;
